import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import StarRating from './StarRating/StarRating';
import Skeleton from '@mui/material/Skeleton';
// ------------------------------------------------------------------------------------------

function DummyReviewCard()
{
    return ( 
        <Card sx={{ marginBottom: '30px' }}>
            <CardContent>            

                { /* Review title */ }
                <Grid container>                
                    <Grid item xs={12} mb={0}>
                        <Skeleton width={200} height={40} />
                    </Grid>
                </Grid>
                <Grid container mb={3}>

                    { /* Score and source logo */ }
                    <Grid item xs={9} sm={6}>
                        <StarRating value={0} />
                    </Grid>
                </Grid>

                <Grid container>

                    { /* Review text and author */ }
                    <Grid item xs={12}>
                        <Skeleton width="100%" height={30} />
                        <Skeleton width="100%" height={30} />
                        <Skeleton width="100%" height={30} />
                        <Skeleton width="100%" height={30} />
                    </Grid>

                    { /* Verification, review ID and date */ }
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Skeleton width={140} height={30} />
                        </Grid>
                        <Grid item xs={6} sx={{ textAlign: 'right' }}>
                            <Skeleton width={250} height={30} />                          
                        </Grid>
                    </Grid>


                    { /* Questions and answers breakdown */ }
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={6}>
                                <Skeleton width="100%" height={30} />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton width="100%" height={30} />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={6}>
                                <Skeleton width="100%" height={30} />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton width="100%" height={30} />
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </CardContent>
        </Card>
    )
}

export default DummyReviewCard;